import styles from '../InformationsForms/InformationFormsStyle.module.scss'
import { Col, Form, Input, Row } from "antd"
const FullAddressField = ({ onChange, formValues, disabled, isForm = true , errors,employerInfo,prefix=""}) => {
    const address1 = errors?.[`${prefix}address1`]

    const addressValue1 = formValues?.[`${prefix}address1`]
    const addressValue2 = formValues?.[`${prefix}address2`]
    return (
        <div className={styles.formContainer}>
             <Row gutter={16} className={styles.gridContainer}>
                <Col xs={24} md={12} lg={12}>
                    {
                        isForm ? (
                            <>
                                <Form.Item layout="vertical" label="Address 1" required  validateStatus={address1 ? 'error' : ''}
                                help={address1}>
                                <Input size="large" fullWidth placeholder="Address 1" id="address1" name={`${prefix}address1`} disabled={disabled} onChange={onChange} value={addressValue1 || ""} />
                                </Form.Item>
                            </>
                        ) : (
                            <div className="showFormField"><span><b>Address 1</b> {employerInfo?.[`${prefix}address1`] || ""}</span></div>
                        )
                    }
                </Col>
                <Col xs={24} md={12} lg={12}>
                    {
                        isForm ? (
                            <>
                                <Form.Item layout="vertical" label="Address 2" validateStatus={''}
                                help={null}>
                                <Input size="large" fullWidth placeholder='Address 2' id="address2" name={`${prefix}address2`} disabled={disabled} onChange={onChange} value={addressValue2 || ""} />
                                </Form.Item>
                            </>
                        ) : (
                            <div className="showFormField"><span><b>Address 2</b> {employerInfo?.[`${prefix}address2`] || ""}</span></div>
                        )
                    }
                </Col>
            </Row>
        </div>
    )
}
export default FullAddressField